export default __webpack_public_path__ + "static/media/phone_icon.31f932c3.svg";